import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate, useSearchParams } from 'react-router-dom';

const EmailVerification = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const { verifyEmail } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const verifyEmailToken = async () => {
      const token = searchParams.get('token');
      
      if (!token) {
        setError('Invalid verification link');
        setLoading(false);
        return;
      }

      try {
        const result = await verifyEmail(token);
        
        if (result.success) {
          setSuccess(true);
          setError('');
          // Redirect to home page after 3 seconds
          setTimeout(() => {
            navigate('/');
          }, 3000);
        } else {
          setError(result.error);
        }
      } catch (err) {
        setError('Verification failed. Please try again.');
      }
      
      setLoading(false);
    };

    verifyEmailToken();
  }, [verifyEmail, searchParams, navigate]);

  return (
    <div className="verification-page">
      <div className="verification-container">
        {loading ? (
          <div className="verification-loading">
            <div className="spinner"></div>
            <h2>Verifying your email...</h2>
            <p>Please wait while we verify your email address.</p>
          </div>
        ) : success ? (
          <div className="verification-success">
            <div className="success-icon">✓</div>
            <h2>Email Verified Successfully!</h2>
            <p>
              Your email has been verified and you are now logged in.
              You will be redirected to the home page in a few seconds.
            </p>
            <button 
              className="btn-continue" 
              onClick={() => navigate('/')}
            >
              Continue to PakaiNow
            </button>
          </div>
        ) : (
          <div className="verification-error">
            <div className="error-icon">⚠️</div>
            <h2>Verification Failed</h2>
            <p>{error}</p>
            <div className="error-actions">
              <button 
                className="btn-home" 
                onClick={() => navigate('/')}
              >
                Go to Home
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default EmailVerification;